import mutations from './mutations';
import actions from './actions';

export const initialState = {
  open: false,
  color: null,
  text: null,
  timeout: null
};

const snackbar = {
  namespaced: true,
  state: { ...initialState },
  mutations,
  actions,
  getters: {}
};

export default snackbar;
